import { render, staticRenderFns } from "./GetStartedPage.vue?vue&type=template&id=733c152c&scoped=true"
import script from "./GetStartedPage.vue?vue&type=script&lang=js"
export * from "./GetStartedPage.vue?vue&type=script&lang=js"
import style0 from "./GetStartedPage.vue?vue&type=style&index=0&id=733c152c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c152c",
  null
  
)

export default component.exports